import Styles from './ColorDivider.module.css'

export interface ColorDividerProps {
  variant: '1' | '2' | '3'
  isThick?: boolean
  hasDucky?: boolean
}

export const defaultProps: Partial<ColorDividerProps> = {}

export const ColorDivider = (props: ColorDividerProps) => {
  const initializedProps: ColorDividerProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return <div className={Styles['ColorDivider']}>ColorDivider</div>
}
